import React, { ReactNode, useState, useImperativeHandle, useRef, forwardRef, useEffect } from 'react';
import DealInfo from '../../../components/DealInfo/index';
import { Button, Checkbox } from '@tencent/spaui';
import './info-common.scss';

interface Props {
  nextStep?: ReactNode;
  onSubmit?: (data: any) => void;
}

const submitData = {
  accepted_agreement: 1,
};

// 协议
// eslint-disable-next-line react/display-name
const BaseInfo: React.FC<Props> = forwardRef((props, cref) => {
  const [value, setValue] = useState(false);

  const submit = () => {
    if (!value) {
      return;
    }
    props.onSubmit?.(submitData);
    return submitData;
  };

  const contentRef = useRef();
  useImperativeHandle(cref, () => ({
    submit,
  }));

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <div ref={contentRef}>
      <div className="info-content">
        <DealInfo />
        <Checkbox
          style={{
            display: 'block',
            textAlign: 'center',
          }}
          value="1"
          checked={!!value}
          onChange={(event: EventTarget, value) => {
            setValue(value);
          }}
        >
          我已认真阅读并充分理解本协议，愿意使用本协议下服务的同时接受协议内容的条款和条件
        </Checkbox>
      </div>
      <div onClick={submit} style={{ display: 'inline-block' }}>
        <Button disabled={!value} className="next-step" displayType="primary">
          确认同意并提交
        </Button>
      </div>
    </div>
  );
});

export default BaseInfo;
